import React from 'react'
import ModalApp from './shared/modal/ModalApp'
import { Row, Col } from 'react-bootstrap'
import TextField from './form-fields/TextField'
import { patternRgx } from '../utils/formValidator'
import { useForm } from 'react-hook-form'
import { requestOriModalText } from '../utils/confirmationMessage'
import { maxLength } from '../utils/errorMessage'

const defaultValues = {
    ori: "",
    agencyName: "",
    comment: "",
};
const RequestOriModal = ({ show, onClose, onSave }) => {
    const { control, getValues, handleSubmit, reset } = useForm({ defaultValues, mode: 'all' })

    const handleModalSubmit = async () => {
        const values = getValues();
        await onSave(values);
        reset(defaultValues); // Reset the form to its initial state
    };

    const handleCancel = () => {
        reset(defaultValues); // Reset the form
        onClose();
    }

    return (
        <ModalApp show={show} onClose={handleCancel} onSave={handleSubmit(handleModalSubmit)} title={"Request to Add an ORI Number"}
            saveBtnTitle={"Submit Request"} cancelBtnTitle={"Cancel"} modalStyle={'request-ori-modal'} cancelBtnStyle={'request-ori-cancel-btn'} saveBtnStyle={'request-ori-submit-btn'}
        >
            <div className='request-ori-text-modal'>
                {requestOriModalText()}
            </div>
            <Row>
                <Col md={6}>
                    <TextField
                        control={control}
                        name={'ori'}
                        label={'ORI Number'}
                        type={'text'}
                        rules={{
                            required: "Required",
                            pattern: patternRgx.nineCharAlphaNumeric
                        }}
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        control={control}
                        name={'agencyName'}
                        label={'Agency Name'}
                        type={'text'}
                        rules={{
                            maxLength: {
                                value: 32,
                                message: maxLength(32),
                            },
                            pattern: patternRgx.alphaNumericSpacesDashesUnderScoreAndParentheses

                        }}

                    />
                </Col>

            </Row>
            <Row>
                <Col md={12}>
                    <TextField
                        control={control}
                        name={'comment'}
                        label={'Additional Comments'}
                        type={'text'}
                        as={'textarea'}
                        textAreaRows={4}
                        rules={{
                            maxLength: {
                                value: 100,
                                message: maxLength(100),
                            },
                        }}
                    />
                </Col>

            </Row>

        </ModalApp>
    )
}

export default RequestOriModal